import '../styles/app.scss';
import Loader from './loader';

new Loader(false);
